import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/dashboard`

    return {
        index(queryParms = {}) {
            return repository.get(`${baseUrl}?${urlUtil.serialize(queryParms)}`)
        },
    }
}